import { createRoutine } from 'redux-saga-routines';

export const routine = createRoutine('RESTORE_FORM/SUBMIT');
